import React from 'react';

interface ChartRangeSliderProps {
  totalPoints: number;
  startIndex: number;
  endIndex: number;
  onChange: (startIndex: number, endIndex: number) => void;
}

const ChartRangeSlider: React.FC<ChartRangeSliderProps> = ({
  totalPoints,
  startIndex,
  endIndex,
  onChange,
}) => {
  if (totalPoints <= 1) {
    return null;
  }

  const maxIndex = totalPoints - 1;
  const leftPct = (startIndex / maxIndex) * 100;
  const rightPct = (endIndex / maxIndex) * 100;

  return (
    <div className="pt-3" data-testid="chart-range-slider">
      <div className="relative h-8 overflow-visible">
        <div className="absolute inset-x-2 top-1/2 h-1 -translate-y-1/2 rounded-full bg-rs-jet-light/80" />
        <div
          className="absolute inset-x-2 top-1/2 h-1 -translate-y-1/2 rounded-full bg-rs-green/80"
          style={{
            left: `${leftPct}%`,
            right: `${100 - rightPct}%`,
          }}
        />
        <input
          type="range"
          min={0}
          max={maxIndex}
          value={startIndex}
          onChange={(event) => {
            const nextStart = Math.min(Number(event.target.value), endIndex - 1);
            onChange(Math.max(0, nextStart), endIndex);
          }}
          className="absolute inset-y-0 inset-x-2 z-20 h-full w-auto appearance-none bg-transparent pointer-events-none
            [&::-webkit-slider-thumb]:appearance-none
            [&::-webkit-slider-thumb]:w-3.5
            [&::-webkit-slider-thumb]:h-3.5
            [&::-webkit-slider-thumb]:rounded-full
            [&::-webkit-slider-thumb]:bg-rs-green
            [&::-webkit-slider-thumb]:border-0
            [&::-webkit-slider-thumb]:pointer-events-auto
            [&::-webkit-slider-thumb]:cursor-ew-resize
            [&::-webkit-slider-runnable-track]:bg-transparent
            [&::-moz-range-thumb]:w-3.5
            [&::-moz-range-thumb]:h-3.5
            [&::-moz-range-thumb]:rounded-full
            [&::-moz-range-thumb]:bg-rs-green
            [&::-moz-range-thumb]:border-0
            [&::-moz-range-thumb]:pointer-events-auto
            [&::-moz-range-thumb]:cursor-ew-resize
            [&::-moz-range-track]:bg-transparent"
          aria-label="Chart range start"
        />
        <input
          type="range"
          min={0}
          max={maxIndex}
          value={endIndex}
          onChange={(event) => {
            const nextEnd = Math.max(Number(event.target.value), startIndex + 1);
            onChange(startIndex, Math.min(maxIndex, nextEnd));
          }}
          className="absolute inset-y-0 inset-x-2 z-30 h-full w-auto appearance-none bg-transparent pointer-events-none
            [&::-webkit-slider-thumb]:appearance-none
            [&::-webkit-slider-thumb]:w-3.5
            [&::-webkit-slider-thumb]:h-3.5
            [&::-webkit-slider-thumb]:rounded-full
            [&::-webkit-slider-thumb]:bg-rs-green
            [&::-webkit-slider-thumb]:border-0
            [&::-webkit-slider-thumb]:pointer-events-auto
            [&::-webkit-slider-thumb]:cursor-ew-resize
            [&::-webkit-slider-runnable-track]:bg-transparent
            [&::-moz-range-thumb]:w-3.5
            [&::-moz-range-thumb]:h-3.5
            [&::-moz-range-thumb]:rounded-full
            [&::-moz-range-thumb]:bg-rs-green
            [&::-moz-range-thumb]:border-0
            [&::-moz-range-thumb]:pointer-events-auto
            [&::-moz-range-thumb]:cursor-ew-resize
            [&::-moz-range-track]:bg-transparent"
          aria-label="Chart range end"
        />
      </div>
    </div>
  );
};

export default ChartRangeSlider;